/**
 * This type provides the available languages for this app.
 */
export enum LanguageType {
  DE = "Deutsch",
  EN = "English",
  JA = "Japanese",
}
